import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { Currency } from '@seapoint/server/enums';
import { Button } from '../../../design-system/button/button';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalDescription,
  ModalTitle,
} from '../../../design-system/modal/modal';
import { Stack } from '../../../design-system/stack/stack';

type BankFeedDisconnectConfirmationModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  accountName: string;
  currency: Currency;
  onClose: () => void;
  onDisconnect: () => Promise<void>;
};

export const BankFeedDisconnectConfirmationModal = ({
  isOpen,
  isLoading,
  accountName,
  currency,
  onClose,
  onDisconnect,
}: BankFeedDisconnectConfirmationModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-max w-[520px]">
        <VisuallyHidden>
          <ModalTitle>Disconnect bank feed confirmation</ModalTitle>

          <ModalDescription>Disconnect bank feed confirmation</ModalDescription>
        </VisuallyHidden>

        <ModalCloseButton onClick={onClose} aria-label="Close modal" />

        <Stack space={10} align="stretch" className="p-7">
          <Stack space={4} align="stretch">
            <h3 className="text-xl leading-6 font-medium tracking-tight text-black">
              Disconnect {accountName} ({currency})
            </h3>

            <p className="text-base leading-6 font-medium tracking-tight text-muted-foreground">
              Are you sure you want to disconnect this account? This will stop sending transactions made from this
              account to Xero.
            </p>
          </Stack>

          <Button variant="destructive" isLoading={isLoading} onClick={onDisconnect}>
            Disconnect Account
          </Button>
        </Stack>
      </ModalContent>
    </Modal>
  );
};
